// src/components/admin/DevolucionEstadoSelect.jsx
import Select from "./Select";
import { DEV_ESTADOS } from "../Utiles/helpers";

const DevolucionEstadoSelect = ({ value, onChange, className }) => (
  <Select value={String(value ?? 0)} onChange={(e) => onChange(Number(e.target.value))} className={className || "w-[220px]"}>
    {DEV_ESTADOS.map((o) => (
      <option key={o.code} value={o.code}>
        {o.label}
      </option>
    ))}
  </Select>
);

export default DevolucionEstadoSelect;
